var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_help_547021",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18114",
    "data-name": "Rectangle 18114",
    width: 14,
    height: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36598",
    "data-name": "Path 36598",
    d: "M10.707,10.113c-2.868,0-5.18,2.033-5.18,4.539s2.311,4.539,5.18,4.539a5.708,5.708,0,0,0,2.813-.724,3.151,3.151,0,0,0,1.977.362.145.145,0,0,0,.056-.265,2.144,2.144,0,0,1-.822-1.058,4.169,4.169,0,0,0,1.156-2.855C15.887,12.146,13.561,10.113,10.707,10.113Zm.348,6.377a.214.214,0,0,1-.209.209h-.515a.214.214,0,0,1-.209-.209v-.334a.214.214,0,0,1,.209-.209h.515a.214.214,0,0,1,.209.209Zm.822-2.019a1.411,1.411,0,0,1-.529.46.784.784,0,0,0-.237.251.987.987,0,0,0-.056.237.137.137,0,0,1-.139.125h-.641a.135.135,0,0,1-.139-.153.825.825,0,0,1,.125-.418,1.84,1.84,0,0,1,.5-.446.84.84,0,0,0,.292-.292.749.749,0,0,0,.111-.39.557.557,0,0,0-.125-.376.423.423,0,0,0-.348-.139.459.459,0,0,0-.306.111.4.4,0,0,0-.111.181.209.209,0,0,1-.209.153l-.6-.014a.128.128,0,0,1-.125-.139A.943.943,0,0,1,9.7,12.9a1.575,1.575,0,0,1,.989-.292,1.48,1.48,0,0,1,1.03.334,1.127,1.127,0,0,1,.376.891A1.147,1.147,0,0,1,11.876,14.471ZM3.647,13.413A3.426,3.426,0,0,1,2.7,11.06,4.048,4.048,0,0,1,6.975,7.3a4.4,4.4,0,0,1,3.732,1.922h0a5.871,5.871,0,0,0-6.057,4.985h0A2.485,2.485,0,0,1,3.02,14.5a.111.111,0,0,1-.042-.209A1.928,1.928,0,0,0,3.647,13.413Z",
    transform: "translate(-2.353 -6.584)",
    fill: "#03dac5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupportIcon);
export default __webpack_public_path__ + "static/media/HelpSupportIcon.52fc6511ea7d83fc47b19d672189244d.svg";
export { ForwardRef as ReactComponent };